import { render, staticRenderFns } from "./IconLang.vue?vue&type=template&id=f014ef76&"
import script from "./IconLang.vue?vue&type=script&lang=ts&"
export * from "./IconLang.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports